module.exports = __webpack_public_path__ + "static/media/goto-fight.ea17eca3.png";